import {apiTemplate} from "@/core/helpers/api.js";

export class Categories {
  static async getCategories() {
    const userLocale = localStorage.getItem('fpt-user-locale');

    const response = await apiTemplate(
      {
        "Content-Type": "application/json",
        "Accept-language": userLocale ? userLocale : 'en-gb'
      },
      `query {
        categories {
          edges {
            node {
              name
              uuid
              image
              description
              slug
            }
          }
        }
      }`
    );

    return await response;
  }

  static async getCategoryBySlug(category) {
    const userLocale = localStorage.getItem('fpt-user-locale');

    const response = await apiTemplate(
      {
        "Content-Type": "application/json",
        "Accept-language": userLocale ? userLocale : 'en-gb'
      },
      `query {
        categories (slug: "${category}") {
          edges {
            node {
              name
              uuid
              image
              description
              slug
              filterableAttributes {
                possibleValues
                attributeName
              }
              minMaxPrices {
                maxPrice
                minPrice
              }
            }
          }
        }
      }`
    );

    return await response;
  }
}